import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import hi from "./locales/hi.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import authenticated from "./authenticated";
import pages from "./pages";
import extra from "./extra";
import extraLanguages from "./extraLanguages";
import regionGlobal from "./regionGlobal";
import advancedPrediction from "./advancedPrediction";

export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिंदी" },
  { code: "de", label: "German", native: "Deutsch" },
  { code: "es", label: "Spanish", native: "Español" },
  { code: "fr", label: "French", native: "Français" },
  { code: "pt", label: "Portuguese", native: "Português" },
  { code: "ru", label: "Russian", native: "Русский" }
];
export const SUPPORTED_LANGUAGE_CODES = LANGUAGES.map(({ code }) => code);
const LANGUAGE_KEY = "gentleflow_lang";
const EXPLICIT_LANGUAGE_KEY = "gentleflow_lang_user_set";
export const isSupportedLanguage = (code) => SUPPORTED_LANGUAGE_CODES.includes(code);
export const getStoredLanguage = () => { try { const stored = localStorage.getItem(LANGUAGE_KEY); return isSupportedLanguage(stored) ? stored : null; } catch { return null; } };
export const persistLanguage = (code) => { if (!isSupportedLanguage(code)) return; try { localStorage.setItem(LANGUAGE_KEY, code); localStorage.setItem(EXPLICIT_LANGUAGE_KEY, "1"); } catch {} };

const mergeResources = (base, code) => {
  const baseExtra = extra.en || {};
  const languageExtra = extra[code] || {};
  const globalEn = regionGlobal.en || {};
  const globalLanguage = regionGlobal[code] || {};
  return {
    ...base,
    app: authenticated[code]?.app || authenticated.en.app,
    contact: authenticated[code]?.contact || authenticated.en.contact,
    pages: pages[code] || pages.en,
    ...baseExtra,
    ...languageExtra,
    ...(extraLanguages[code] || {}),
    advancedPrediction: advancedPrediction[code] || advancedPrediction.en,
    region: { ...(base.region || {}), ...(baseExtra.region || {}), ...(languageExtra.region || {}), ...(globalEn.region || {}), ...(globalLanguage.region || {}) },
    plus: { ...(base.plus || {}), ...(baseExtra.plus || {}), ...(languageExtra.plus || {}), ...(globalEn.plus || {}), ...(globalLanguage.plus || {}) }
  };
};

const initialLang = getStoredLanguage() || "en";
i18n.use(initReactI18next).init({ resources: Object.fromEntries(SUPPORTED_LANGUAGE_CODES.map(code => [code, { translation: mergeResources({ en, hi, de, es, fr, pt, ru }[code], code) }])), lng: initialLang, fallbackLng: "en", supportedLngs: SUPPORTED_LANGUAGE_CODES, interpolation: { escapeValue: false }, react: { useSuspense: false } });
i18n.on("languageChanged", (language) => { const normalized = language?.split("-")[0]; if (isSupportedLanguage(normalized)) persistLanguage(normalized); });
export default i18n;
